export default "__VITE_ASSET__2kqlCyE9__"